var _metadata, _defs, _sodipodiNamedview, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenCirclePlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    id: "svg22",
    sodipodiDocname: "GreenCirclePlus.svg",
    inkscapeVersion: "1.0.2-2 (e86c870879, 2021-01-15)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata28"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs26"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1017,
    id: "namedview24",
    showgrid: "false",
    inkscapeZoom: 8.0138769,
    inkscapeCx: 41.081729,
    inkscapeCy: 39.319035,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 64.016504,10.983496 c -14.6212,-14.6212008 -38.411808,-14.6212008 -53.033008,0 -14.6212008,14.6212 -14.6212008,38.411808 0,53.033008 14.6212,14.621201 38.411808,14.621201 53.033008,0 14.621201,-14.6212 14.621201,-38.411808 0,-53.033008 z m -22.76707,45.078128 h -7.498868 v -14.81219 h -14.81219 l 7.1e-5,-7.498797 14.812119,-7.1e-5 7.1e-5,-14.812119 7.498726,0 7.1e-5,14.812119 14.812119,7.1e-5 7.1e-5,7.498797 h -14.81219 z",
    fill: "#018626",
    id: "path20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCirclePlus);
export default __webpack_public_path__ + "static/media/GreenCirclePlus.fcb402b36a94ce0d421b7c680cd43175.svg";
export { ForwardRef as ReactComponent };